<template>
  <layout-default-appbar filterabl>
      Posição Armazém
  </layout-default-appbar>
</template>

<script>
import LayoutDefaultAppbar from '@/layouts/default/AppBar.vue';
import { ROUTE_PRODUCAO } from '@/constants/ROUTES';

export default {
  name: 'ViewArmazemAppBar',

  components: {
    LayoutDefaultAppbar,
  },

    data() {
    return {
      rota: ROUTE_PRODUCAO,
    }
  }

};
</script>
